const apiBaseName =
  process.env.NODE_ENV === "production"
    ? "https://www.tempiodelfuturo.art"
    : "http://localhost:3000";

const gql = async (query, variables) => {
  const res = await fetch(`${apiBaseName}/admin/api`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });
  return await res.json();
};

export { apiBaseName, gql };
